@if (imageSrc) {
  <div class="avatar-image" [style.backgroundImage]="'url(' + imageSrc + ')'" [ngClass]="panelClass"></div>
} @else {
  <div class="avatar-image label" [ngClass]="panelClass">
    @if (label) {
      <span>{{ label?.substr(0, 2) }}</span>
    }
  </div>
}
